"use client";

import { styled } from "styled-components";

export const Border = styled.div<{ $width: number; $height: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #2a2f37;

  width: ${({ $width }) => $width / 10}rem;
  height: ${({ $height }) => $height / 10}rem;
`;
